import { lazyComponent } from "@/client/lib/lazy-component";

// Home's closed popups, out of its first load with the date parser and the menu, list and dialog
// primitives they bring: none is drawn on the first screen. Each is fetched by its first opening,
// or before: quick add and the palette once the shell has mounted, the rest by `every-chunk.ts`.

export const rowDatePicker = lazyComponent(() =>
  import("@/client/components/row-date-picker").then((m) => m.RowDatePicker),
);

export const quickAddSheet = lazyComponent(() =>
  import("@/features/tasks/components/quick-add-sheet").then(
    (m) => m.QuickAddSheet,
  ),
);

export const switcherMenu = lazyComponent(() =>
  import("@/client/components/company-switcher-menu").then(
    (m) => m.SwitcherMenu,
  ),
);

export const commandPalette = lazyComponent(() =>
  import("@/client/components/command-palette").then((m) => m.CommandPalette),
);

export const settingsWindow = lazyComponent(() =>
  import("@/client/components/settings-window").then((m) => m.SettingsWindow),
);

export const signedOutDialog = lazyComponent(() =>
  import("@/client/components/signed-out-dialog").then(
    (m) => m.SignedOutDialog,
  ),
);

export const shortcutSheet = lazyComponent(() =>
  import("@/client/components/shortcut-sheet").then((m) => m.ShortcutSheet),
);

export const POPUPS = [
  rowDatePicker,
  quickAddSheet,
  switcherMenu,
  commandPalette,
  settingsWindow,
  signedOutDialog,
  shortcutSheet,
];
